module.exports = __webpack_public_path__ + "static/media/react_2.a84134b7.webp";